"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChargerPortStateValidation = void 0;
class ChargerPortStateValidation {
    static isValid(enumValue) {
        if (typeof enumValue !== "number")
            return false;
        if (!(0 <= enumValue && enumValue <= 8)) {
            return false;
        }
        return true;
    }
}
exports.ChargerPortStateValidation = ChargerPortStateValidation;
